import InternalsList from "../views/InternalsList"
import InternalsDetail from "../views/InternalsDetail"
import InternalsCreate from "../views/InternalsCreate"
import InternalsBulkUpload from "../views/InternalsBulkUpload"

import InternalSubscriptions from "../components/mockedApeiron/InternalSubscriptions"

export default [
	{
		path: "/:tenantId/internals",
		component: InternalsList,
		meta: { featureId: "internals" },
		name: "InternalsList"
	},
	{
		path: "/:tenantId/internals/detail/:id",
		component: InternalsDetail,
		meta: { featureId: "internals" },
		name: "InternalsDetail"
	},
	{
		path: "/:tenantId/internals/create",
		component: InternalsCreate,
		meta: { featureId: "internals" },
		name: "InternalsCreate"
	},
	{
		path: "/:tenantId/internals/upload",
		component: InternalsBulkUpload,
		meta: { featureId: "internals" },
		name: "InternalsBulkUpload"
	},

	{
		path: "/:tenantId/internals/detail/:id/subscriptions",
		component: InternalSubscriptions,
		meta: { featureId: "internals" },
		name: "InternalSubscriptions"
	}
]
